import {detailServicesPath} from "../../../Constants";
import axios from "axios";

const detailControllerRestUrl = detailServicesPath + '/organizations/details-order/'

export default class DetailControllerServiceOrganization {
    static async exportFile(detailId, postprocessorSettingsId) {
        return axios.get(`${detailControllerRestUrl}${detailId}/file?postprocessorSettingsId=${postprocessorSettingsId}`);
    }

    static async exportAllFiles(requestsCuttingId, postprocessorSettingsId, ids) {
        const query = ids.length > 0 ? `&detailIds=${ids}` : ""
        return axios.get(`${detailControllerRestUrl}files?requestsCuttingId=${requestsCuttingId}&postprocessorSettingsId=${postprocessorSettingsId}${query}`, {
            responseType: 'blob'
        });
    }

    static async getDetail(id) {
        return axios.get(`${detailControllerRestUrl}export/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getDetailByRequestsCuttingId(requestsCuttingId) {
        return axios.get(`${detailControllerRestUrl}export/by-requests-cutting-id?requestsCuttingId=${requestsCuttingId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async rotateClockwise(id) {
        return axios.patch(`${detailControllerRestUrl}export/${id}/rotate-clockwise`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async rotateCounterClockwise(id) {
        return axios.patch(`${detailControllerRestUrl}export/${id}/rotate-counterclockwise`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async resetRotate(id) {
        return axios.patch(`${detailControllerRestUrl}export/${id}/reset-rotation`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async mirrorVertically(id) {
        return axios.patch(`${detailControllerRestUrl}export/${id}/mirror-vertically`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async mirrorHorizontally(id) {
        return axios.patch(`${detailControllerRestUrl}export/${id}/mirror-horizontally`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}


